// src/config/productos.js
// Configuraciones específicas para el módulo de productos
import productoPlaceholder from '../assets/producto-placeholder.jpg'

export const PRODUCTOS_NO_IMAGE = productoPlaceholder
export const PRODUCTOS_FETCH_CUANTOS = 10
export const MAX_IMAGENES = 6
export const HABILITAR_FICHA_TECNICA = true
export const MODULO_PROMOCIONES = true
export const MANEJO_CANTIDADES = true
// Habilitar sistema de atributos/variantes
export const HABILITAR_ATRIBUTOS = true